import { Heading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const Title = styled(Heading).attrs({ tag: 'h2', styledAs: 'h5', noMargin: true })`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  font-size: 14px;
  background: white;
  gap: 24px;
`;
